import api from './api';

export const patchCustomization = (eventId, data) =>
  api.patch(`/events/${eventId}/customization`, data);

export const createPremiumCheckout = (eventId, cardToken) =>
  api.post(`/events/${eventId}/premium-checkout`, { card_token: cardToken });

export const uploadCustomizationBackground = (eventId, file) => {
  const form = new FormData();
  form.append('background', file);
  return api.post(`/events/${eventId}/customization/background`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

